import {FormControl, Grid} from '@mui/material';
import styled from '@emotion/styled';
import {APP} from 'src/styles/variables';

interface FormControlDivProps {
  width?: string;
}

export const InputFieldGrid = styled(Grid)`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const FormControlDiv = styled(FormControl)<FormControlDivProps>`
  width: ${({width}) => width || '100%'};
`;

// export const FormControlDiv = styled(FormControl)`
//   width: 100%;
// `;

export const ContainerGridStyle = styled(Grid)`
  width: 90%;
`;

export const SelectionListDiv = styled('div')`
  margin: 1rem;
  border: 1px solid ${APP.PALETTE.COMMON.BORDER_GRAY_COLOR};
  padding: 1rem;
  max-height: 50vh;
  min-height: auto;
  overflow: auto;
  border-radius: 1%;
`;
